import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer" id="contact">
      <div className="footer__inner">
        <div className="footer__brand">
          <Link to="/" className="footer__logo">
            Villa Mandragora
          </Link>
        </div>

        <div className="footer__address">
          <p>Villa Mandragora</p>
          <p>Orahovac, Kotor</p>
          <p>Montenegro</p>
        </div>

        <div className="footer__contacts">
          <p>
            <span>Tel:</span>
            <a href="tel:+38267429342">+382 67 429 342</a>
          </p>

          <p>
            <span>Email:</span>
            <a href="mailto:info@villamandragora.me">
              info@villamandragora.me
            </a>
          </p>
        </div>
      </div>

      <div className="footer__nav">
        <Link to="/" className="footer__nav-link">Home</Link>
        <Link to="/location" className="footer__nav-link">location</Link>
        <Link to="/gallery" className="footer__nav-link">Gallery</Link>
        <Link to="/reservation" className="footer__nav-link">Reserve</Link>
        {/* <a href="https://airbnb.com/..." className="footer__nav-link" target="_blank" rel="noreferrer">Airbnb</a>
        <a href="https://booking.com/..." className="footer__nav-link" target="_blank" rel="noreferrer">Booking.com</a>*/}
        <a href="https://www.instagram.com/villamandragora" className="footer__nav-link" target="_blank" rel="noreferrer">Instagram</a>
        {/* <a href="https://www.vrbo.com/5249034" className="footer__nav-link" target="_blank" rel="noreferrer">VRBO</a> */}
        <Link to="/contact" className="footer__nav-link">Contact</Link>
      </div>

      <div className="footer__bottom">
        <p>© {new Date().getFullYear()} Villa Mandragora. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
